const dataTypeTitles = {
  string: 'Text',
  number: 'Number',
  boolean: 'Boolean',
  date: 'Date',
  list: 'List',
  array: 'Array',
  object: 'Object',
  file: 'File'
};

export default dataTypeTitles;
